module.exports = __webpack_public_path__ + "static/media/morning_birds.b7318500.mp3";